export const PAGE_LOADING = 'page_loading';
export const PAGE_LOADED = 'page_loaded';

export const AUTH_ON_CHANGE = 'auth_on_change'
export const AUTH_ON_LOGIN = 'auth_on_login'
export const AUTH_ON_LOGIN_ERROR = 'auth_on_login_error'
export const AUTH_ON_LOGIN_SUCCESS = 'auth_on_login_success'
export const AUTH_ON_LOGOUT = 'auth_on_logout'

export const PROFILE_POPULATED = 'profile_populated';
export const PROFILE_CHANGED = 'profile_changed';

export const ANALYTICS_INITIAL_STATE = 'analytics_initial_state';
export const ANALYTICS_POPULATE = 'analytics_populate';
export const SELECT_LOCATIONS = 'select_locations';
export const SELECT_DATES = 'select_dates';

export const GET_REPORTS_DATA = 'get_reports'
export const GET_REPORTS_LIST = 'get_reports_list'
export const EMPTY_REPORT_DATA = 'empty_report_data'
export const GET_TRENDING_DATA = 'get_trending_data'
export const GET_METRIC_LIST = 'get_metric_list'
export const UPDATE_TOP_ITEMS = 'update_top_items'
export const UPDATE_LOWEST_ITEMS = 'update_lowest_items'

export const INVENTORY_POPULATE = 'INVENTORY_POPULATE'

export const PRODUCT_ANALYTICS_POPULATE = 'PRODUCT_ANALYTICS_POPULATE'



// WEBPACK FOOTER //
// ./src/constants/types.js